type Copy = Record<string, string>

const copies: Record<string, Copy> = {
  en: {
    Analytics: 'Analytics',
    'SEO Title': 'SEO Title',
    'SEO Description': 'SEO Description',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': 'Server-side page title for search engines and social sharing. Leave empty to use the system name.',
    'Server-side meta description shown in search results and LLM search snippets.': 'Server-side meta description shown in search results and LLM search snippets.',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': 'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.',
  },
  zh: {
    Analytics: '数据分析',
    'SEO Title': 'SEO 标题',
    'SEO Description': 'SEO 描述',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': '用于搜索引擎和社交分享的服务器端页面标题。留空则使用系统名称。',
    'Server-side meta description shown in search results and LLM search snippets.': '显示在搜索结果和大模型搜索摘要中的服务器端元描述。',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': '即时体验 GLM、Kimi、Minimax 和 Seedance 2.5 等模型，无需 API 密钥。',
  },
  ja: {
    Analytics: 'データ分析',
    'SEO Title': 'SEO タイトル',
    'SEO Description': 'SEO 説明',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': '検索エンジンとSNS共有用のサーバー側ページタイトルです。空欄の場合はシステム名を使用します。',
    'Server-side meta description shown in search results and LLM search snippets.': '検索結果とLLM検索スニペットに表示されるサーバー側のメタ説明です。',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': 'GLM、Kimi、Minimax、Seedance 2.5 などのモデルを、APIキーなしですぐに試せます。',
  },
  fr: {
    Analytics: 'Analytique',
    'SEO Title': 'Titre SEO',
    'SEO Description': 'Description SEO',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': 'Titre de page côté serveur pour les moteurs de recherche et le partage social. Laissez vide pour utiliser le nom du système.',
    'Server-side meta description shown in search results and LLM search snippets.': 'Méta-description côté serveur affichée dans les résultats de recherche et les extraits de recherche LLM.',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': 'Testez instantanément des modèles comme GLM, Kimi, Minimax et Seedance 2.5, sans clé API.',
  },
  ru: {
    Analytics: 'Аналитика',
    'SEO Title': 'SEO-заголовок',
    'SEO Description': 'SEO-описание',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': 'Серверный заголовок страницы для поисковых систем и соцсетей. Оставьте пустым, чтобы использовать имя системы.',
    'Server-side meta description shown in search results and LLM search snippets.': 'Серверное метаописание для результатов поиска и фрагментов поиска LLM.',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': 'Мгновенно тестируйте такие модели, как GLM, Kimi, Minimax и Seedance 2.5, без API-ключа.',
  },
  vi: {
    Analytics: 'Phân tích',
    'SEO Title': 'Tiêu đề SEO',
    'SEO Description': 'Mô tả SEO',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': 'Tiêu đề trang phía máy chủ dành cho công cụ tìm kiếm và chia sẻ xã hội. Để trống để dùng tên hệ thống.',
    'Server-side meta description shown in search results and LLM search snippets.': 'Mô tả meta phía máy chủ hiển thị trong kết quả tìm kiếm và đoạn trích tìm kiếm LLM.',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': 'Trải nghiệm ngay các mô hình như GLM, Kimi, Minimax và Seedance 2.5 mà không cần khóa API.',
  },
  ko: {
    Analytics: '데이터 분석',
    'SEO Title': 'SEO 제목',
    'SEO Description': 'SEO 설명',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': '검색 엔진과 소셜 공유에 사용되는 서버 측 페이지 제목입니다. 비워 두면 시스템 이름을 사용합니다.',
    'Server-side meta description shown in search results and LLM search snippets.': '검색 결과와 LLM 검색 스니펫에 표시되는 서버 측 메타 설명입니다.',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': 'API 키 없이 GLM, Kimi, Minimax, Seedance 2.5 등의 모델을 즉시 테스트해 보세요.',
  },
  tw: {
    Analytics: '數據分析',
    'SEO Title': 'SEO 標題',
    'SEO Description': 'SEO 描述',
    'Server-side page title for search engines and social sharing. Leave empty to use the system name.': '用於搜尋引擎和社群分享的伺服器端頁面標題。留空則使用系統名稱。',
    'Server-side meta description shown in search results and LLM search snippets.': '顯示於搜尋結果和大型語言模型搜尋摘要中的伺服器端中繼描述。',
    'Test models like GLM, Kimi, Minimax and Seedance 2.5 instantly — no API key required.': '立即體驗 GLM、Kimi、Minimax 和 Seedance 2.5 等模型，無需 API 金鑰。',
  },
}

export function getSiteOverrides(language: string): Copy {
  return copies[language] ?? copies.en
}
